fragment HeroProductFragment on heroProduct_Entry {
  typeHandle
  productName
  product {
    ... on products_Entry {
      uri
      shopifyHandle
    }
  }
  heading
  image {
    url
    title
  }
  alt
}
